module.exports = __webpack_public_path__ + "static/media/rate.7086697c.svg";